import "./js/annualreview-worldmap";

jQuery(function ($) {
  console.log("Annual Review ready");

  // Secretary General Message
  $(document).on("click", ".button-open-modal", function (e) {
    e.preventDefault();
    const target = $($(this).data("target"));
    if (target.length > 0) {
      $("#overlay-mask").fadeIn();
      target.delay(500).fadeIn();
      $("body").addClass("overflow-hidden");
    }
  });

  $(".button-close-modal").on("click", function () {
    const target = $($(this).data("target"));

    target.fadeOut();
    $("#overlay-mask").delay(500).fadeOut();
    $("body").removeClass("overflow-hidden");
  });
  // Secretary General Message //////////////////////////////// END

  $(".idea-slider").slick({
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".mission-collapsible").vCollapse({
    any: true,
    onLoad: 0,
    speed: 300,
    easing: "ease-in-out",
    // autoScroll: true,
  });

  // Our Impact Stories
  const impactStoriesTab = $("#impact-tabs");
  impactStoriesTab.vTabs();

  const impactSlides = [];
  $(".impact-slides").each(function () {
    const tabId = $(this).closest(".vtab-content").attr("id");
    const impactSlider = $(this).slick({
      // infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      dots: true,
      // adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
          },
        },
      ],
    });

    impactSlides.push({
      tabId: "#" + tabId,
      slider: impactSlider,
    });
  });

  // refresh slick slider on tab change
  $(".vtab-toggle").on("click", function () {
    const tabId = $(this).data("target");
    const tabTarget = $(tabId);

    if (tabTarget.hasClass("active")) {
      const currentTabData = impactSlides.find((item) => item.tabId === tabId);
      if (currentTabData) {
        currentTabData.slider.slick("refresh");
      }
    }
  });
  // Our Impact Stories /////////////////////////////////// END

  // Count up numbers
  let countUpElements = [];
  const countUp = $(".count-up-numbers");

  countUp.each(function (i) {
    const elm = $(this);
    const incrementSpeed = elm.data("increment")
      ? parseInt(elm.data("increment"))
      : 200;
    const value = parseInt(elm.html().replace(/,/g, ""));
    elm.attr("data-index", i);
    elm.attr("data-value", value);

    // wrap it with span tag to maintain the initial width of the element
    // so that the animation looks smoother and not "shaking" the layout
    elm.wrapInner("<span></span>");

    countUpElements[i] = {
      countStarted: false,
      count: 0,
      value: value,

      // increase the increment based on the value being counted
      incrementBy: Math.ceil(value / incrementSpeed),
    };
  });

  function countUpScroll() {
    let check = true;

    countUp.each(function (i) {
      if ($(this).isInViewport()) {
        const currentElm = countUpElements.find((val, idx) => idx === i);
        if (!currentElm.countStarted) {
          countUpElements[i].countStarted = true;
          countViews(i);
        }
      }

      check = countUpElements[i].countStarted;
    });

    if (check) {
      $(window).off("scroll", countUpScroll);
    }
  }

  $(window).on("scroll", countUpScroll);

  function countViews(i) {
    if (countUpElements[i]) {
      const currentElm = countUpElements[i];
      const countTo = currentElm.value;
      const currentCount = currentElm.count;
      const newCount = currentCount + currentElm.incrementBy;

      countUpElements[i].count = newCount;
      const formattedValue = newCount.toLocaleString("en-GB"); // to get the commas
      $(`.count-up-numbers[data-index=${i}] span`).html(formattedValue);

      if (currentCount < countTo) {
        requestAnimationFrame(() => countViews(i));
      } else {
        $(`.count-up-numbers[data-index=${i}] span`).html(
          countTo.toLocaleString()
        );
      }
    }
  }
  // Count up numbers /////////////////////////////////////// END

  // Progress bar animation
  let themeProgressBars = [];
  const themeBars = $(".theme-progress-bar");

  themeBars.each(function (i) {
    const theme = $(this);
    const value = theme.data("value");
    const total = theme.data("total");

    // const formattedValue = value ? parseInt(value.replace(/,/g, "")) : 0;
    // const formattedTotal = total ? parseInt(total.replace(/,/g, "")) : 0;
    const formattedValue = value ? parseInt(value) : 0;
    const formattedTotal = total ? parseInt(total) : 0;
    const themePercentage =
      formattedTotal > 0 ? formattedValue / formattedTotal : 0;
    const color = theme.data("color");
    // console.log(`item ${i}:`, {
    //   value,
    //   formattedValue,
    //   total,
    //   formattedTotal,
    //   themePercentage,
    // });

    theme.attr("data-index", i);
    if (color) {
      theme.find(".progress-bar__bar").css("background-color", color);
    }

    themeProgressBars[i] = {
      animStarted: false,
      currentPercentage: 0,
      totalPercentage: themePercentage,
    };
  });

  function themeBarsScroll() {
    let check = true;

    themeBars.each(function (i) {
      if ($(this).isInViewport()) {
        const currentElm = themeProgressBars.find((val, idx) => idx === i);
        if (!currentElm.animStarted) {
          themeProgressBars[i].animStarted = true;
          requestAnimationFrame((timestamp) =>
            animateProgressBar(i, timestamp)
          );
        }
      }
      check = themeProgressBars[i].animStarted;
    });

    if (check) {
      $(window).off("scroll", themeBarsScroll);
    }
  }

  $(window).on("scroll", themeBarsScroll);

  let start;
  function animateProgressBar(i, timestamp) {
    if (!start) start = timestamp;
    const progress = Math.min((timestamp - start) / 1000, 1); // Progress from 0 to 1
    const totalPercentage = themeProgressBars[i].totalPercentage;
    const progressPercentage = totalPercentage * progress * 100;
    let widthPercentage = `${progressPercentage.toFixed(2)}%`;

    const barElem = $(`.theme-progress-bar[data-index=${i}]`);
    const rowBar = barElem.find(".progress-bg").attr("data-width");

    barElem.find(".progress-bar__bar").css("width", widthPercentage);
    barElem.find(".progress-bar__percentage").html(widthPercentage);

    barElem.find(".progress-bg").css("width", rowBar + "%");

    if (progress < 1) {
      requestAnimationFrame((timestamp) => animateProgressBar(i, timestamp));
    }
  }
  // Progress bar animation //////////////////////////////////////// END

  // Impact Stories detail page
  $(".impact-stories-images").each(function (index) {
    const elm = $(this);

    const modalSlider = elm.slick({
      autoplay: false,
      slidesToShow: 1,
      arrows: true,
      dots: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
          },
        },
      ],
    });
  });
  // Impact Stories detail page /////////////////////////////////////// END

  // Publications
  if ($(".ar-pub-chart-bar").length > 0) {
    const arPubChartBars = $(".ar-pub-chart-bar");
    let arPubChartBarsChecker = []; // Count for animated bars

    arPubChartBars.each(function (i) {
      const elm = $(this);
      const data = elm.data("data");
      const max = Math.max(...data);
      elm.data("max", max);

      arPubChartBarsChecker[i] = false;
    });

    function arPubChartBarsOnScroll() {
      arPubChartBars.each(function (i) {
        const elm = $(this);
        const max = elm.data("max");

        if (elm.isInViewport()) {
          elm.find(".chart-bar").each(function () {
            const barElm = $(this);
            const value = barElm.data("value");

            const percentage = parseFloat(((value / max) * 100).toFixed(2));

            barElm[0].style.width = `${percentage}%`;

          });

          arPubChartBarsChecker[i] = true;

          if (!arPubChartBarsChecker.includes(false)) {
            $(window).off("scroll", arPubChartBarsOnScroll);
          }
        }
      });
    }

    $(window).on("scroll", arPubChartBarsOnScroll);
  }

  // Publications ///////////////////////////////////// END
});
